import React, { useEffect, useState } from "react";
import css from "./gallerij.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import Seo from "../../components/seo/Seo";
import Reveal from "../../components/animations/Reveal";

interface RequireContext {
    keys(): string[];
    (id: string): string;
    <T>(id: string): T;
    resolve(id: string): string;
    id: string;
}

interface ShuffledImage {
    src: string;
    style: string;
}

function importAll(r: RequireContext): string[] {
    return r.keys().map((key: string): string => r(key));
}

const images = importAll((require as any).context("../../images/gallerij", false, /\.(png|jpe?g|svg|avif)$/));

const Galerij: React.FC = () => {
    const [shuffledImages, setShuffledImages] = useState<ShuffledImage[]>([]);
    const [overlayImage, setOverlayImage] = useState<string | null>(null);

    useEffect(() => {
        const shuffledSrcs = images
            .map((img: string) => ({ img, sort: Math.random() }))
            .sort((a, b) => a.sort - b.sort)
            .map(({ img }) => img);

        const layout: ShuffledImage[] = shuffledSrcs.map((src) => ({
            src,
            style: css.span1x1
        }));

        setShuffledImages(layout);
    }, []);

    return (
        <div className={css.container}>
            <Seo
                title="Galerij | BolleNoord 't Zand B.V."
                description="Bekijk foto’s van onze bollenopslag, faciliteiten en werkzaamheden. Een indruk van onze professionele omgeving en werkwijze."
                path="/galerij"
            />
            <div className={css.intro}>
                <h1>Inspirerende Foto&apos;s van Onze Bollenopslag</h1>
            </div>
            <div className={css.grid}>
                {shuffledImages.map((img: ShuffledImage, index: number) => (
                    <Reveal key={`${img.src}-${index}`} variant="fade-up" delayMs={(index % 6) * 50}>
                        <div
                            className={`${css.imageWrapper} ${img.style}`}
                            onClick={() => setOverlayImage(img.src)}
                        >
                            <img
                                src={img.src}
                                alt={`Bollenopslag ${index + 1}`}
                                className={css.image}
                            />
                        </div>
                    </Reveal>
                ))}
            </div>

            {overlayImage && (
                <div className={css.overlay} onClick={() => setOverlayImage(null)}>
                    <div className={css.overlayContent} onClick={(e) => e.stopPropagation()}>
                        <FontAwesomeIcon icon={faTimes} className={css.closeIcon} onClick={() => setOverlayImage(null)} />
                        <img src={overlayImage} alt="Vergrote afbeelding" className={css.fullImage} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Galerij;